import { useState, useEffect } from 'react';

export const useAppDetection = () => {
  const [isAppInstalled, setIsAppInstalled] = useState(false);
  const [checkingInstallation, setCheckingInstallation] = useState(false);

  useEffect(() => {
    // LOGICA SEMPLIFICATA: Su iOS, assumiamo sempre NON installata
    // e lasciamo che lo Smart App Banner nativo gestisca l'apertura app
    // Gli Universal Links funzioneranno comunque se l'app è installata
    
    // Su tutti i dispositivi: non installata per default
    setIsAppInstalled(false);
    setCheckingInstallation(false);
    
    // NOTA: La detection affidabile dell'app su iOS non è possibile da web
    // senza permessi speciali. Lo Smart App Banner di iOS gestisce già
    // perfettamente questo scenario:
    // - Se app installata → banner mostra "APRI"
    // - Se app non installata → banner mostra "VISUALIZZA"
    
  }, []);

  // Funzione per marcare l'app come installata manualmente
  // (può essere chiamata se ricevi un evento dall'app via postMessage)
  const markAppAsInstalled = () => {
    setIsAppInstalled(true);
  };

  return {
    isAppInstalled,
    checkingInstallation,
    markAppAsInstalled
  };
};
